import { FLOOR_TRAY_PATTERN, PARAPET_TRAY_PATTERN } from "./constants";
import type { SuggestTrayHeight } from "./types";

export const suggestTrayHeight: SuggestTrayHeight = ({ trayType, levels }) => {
  if (FLOOR_TRAY_PATTERN.test(trayType)) return levels.floorM;
  if (PARAPET_TRAY_PATTERN.test(trayType)) return levels.controlsM;
  return levels.ceilingVoidM;
};
